import React, { useMemo } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Collapse,
  Space,
  Button,
  Checkbox,
  Tag,
} from '@lockerpm/design';

import {
  DeleteOutlined,
  SendOutlined
} from "@ant-design/icons";

import itemsComponents from "../../../../../components/items";

import global from "../../../../../config/global";

import {
  convertDateTime,
  wsMemberRole,
  wsMemberStatus
} from '../../../../../utils/common'

const BoxData = (props) => {
  const { TextCopy } = itemsComponents;
  const { t } = useTranslation();
  const {
    loading = false,
    className = '',
    data = [],
    params = {},
    rowSelection = {},
    mailConfig = null,
    onDelete = () => {},
    onReinvite = () => {}
  } = props;

  const userInfo = useSelector((state) => state.auth.userInfo);

  const boxData = useMemo(() => {
    return data.map((d, index) => ({ ...d, stt: index + 1 + (params.page - 1) * params.size }))
  }, [data])

  return (
    <Collapse
      className={className}
      bordered={true}
      expandIconPosition="end"
      size="small"
      collapsible='icon'
    >
      {
        boxData.map((record) => <Collapse.Panel
          key={record.id}
          header={<div
            className="flex align-items justify-between"
          >
            <div className="flex align-items">
              <Checkbox className="mr-2"/>
              <TextCopy
                value={record.user.full_name}
              />
            </div>
            {
              <Space size={[8, 8]}>
                {
                  mailConfig && <Button
                    icon={<SendOutlined />}
                    disabled={record.status !== global.constants.WS_MEMBER_STATUS.CREATED}
                    type={'link'}
                    onClick={() => onReinvite(record)}
                  />
                }
                {
                  record.user?.username !== userInfo?.username && <Button
                    icon={<DeleteOutlined />}
                    type={'link'}
                    size="small"
                    danger
                    onClick={() => onDelete(record)}
                  />
                }
              </Space>
            }
          </div>}
        >
          <div className="flex items-center mb-2">
            <p className="font-semibold mr-2">{t('common.email')}:</p>
            <TextCopy
              value={record.user.username}
            />
          </div>
          <div className="flex items-center mb-2">
            <p className="font-semibold mr-2">{t('common.role')}:</p>
            <Tag
              color={wsMemberRole(record.role)?.color}
            >
              <TextCopy
                value={t(wsMemberRole(record.role)?.label)}
              />
            </Tag>
          </div>
          <div className="flex items-center mb-2">
            <p className="font-semibold mr-2">{t('common.status')}:</p>
            <Tag
              color={wsMemberStatus(record.status)?.color}
            >
              <TextCopy
                value={t(wsMemberStatus(record.status)?.label)}
              />
            </Tag>
          </div>
          <div className="flex items-center">
            <p className="font-semibold mr-2">{t('common.access_date')}:</p>
            <TextCopy
              value={convertDateTime(record.access_date)}
            />
          </div>
        </Collapse.Panel>)
      }
    </Collapse>
  );
}

export default BoxData;
